// extracted by mini-css-extract-plugin
module.exports = {"container":"_80d258fc","icon":"_31f6baf0","label":"_1cf58c9d"};